import React from 'react';
import { 
  FormControl, 
  InputLabel, 
  Select, 
  MenuItem 
} from '@mui/material';

/**
 * Reusable filter selector component
 * @param {Object} props - Component props
 * @param {string} props.value - Current selected value
 * @param {function} props.onChange - Function to handle selection changes
 * @param {string} props.label - Label for the selector
 * @param {Array} props.options - Array of options to display
 * @param {string} props.defaultOption - Text for the default "all" option
 * @param {Object} props.sx - Additional styling
 * @returns {JSX.Element} Filter selector component
 */
const FilterSelector = ({ 
  value, 
  onChange, 
  label, 
  options, 
  defaultOption = "All",
  sx = {} 
}) => {
  return (
    <FormControl fullWidth sx={sx}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label={label}
      >
        <MenuItem value="">{defaultOption}</MenuItem>
        {options.map(option => {
          // Handle both string options and object options with value/label properties
          if (typeof option === 'object' && option !== null && 'value' in option && 'label' in option) {
            return <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>;
          } else {
            return <MenuItem key={option} value={option}>{option}</MenuItem>;
          }
        })}
      </Select>
    </FormControl>
  );
};

export default FilterSelector;
